import { Avatar, type AvatarSize } from "@/components/ui/atoms/Avatar";

interface BotAvatarProps {
  size?: "sm" | "md" | "lg" | "xl";
  className?: string;}

const DEFAULT_AVATAR_SRC = "/chatbot-avatar.jpg";

export function BotAvatar({
  size = "md",
  className,
}: BotAvatarProps) {

  return (
    <Avatar
      initials={"IA"}
      src={DEFAULT_AVATAR_SRC}
      alt="Invirtus Interview Assistant Avatar"
      size={size as AvatarSize}
      variant="neutral"
      className={className}
    />
  );
}
